import moment from "moment";

export const getDiff = (date, now) => {
  const diff = moment(date).diff(now, "days");
  const pastDate = diff < 0;
  return pastDate ? `${Math.abs(diff)} days ago` : `In ${Math.abs(diff)} days`;
};
